"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionCoordinates = exports.QuestionCoordinates = void 0;
const runtypes_1 = require("runtypes");
const languages_1 = require("./languages");
const submission_1 = require("./submission");
exports.QuestionCoordinates = (0, runtypes_1.Record)({
    language: languages_1.Languages,
    path: runtypes_1.String,
    author: runtypes_1.String,
});
exports.SubmissionCoordinates = exports.QuestionCoordinates.And((0, runtypes_1.Record)({
    submissionType: submission_1.SubmissionType,
}));
//# sourceMappingURL=coordinates.js.map